export const pagesTrackingName = {
  recommended: 'index',
  loggedOutLanding: 'index',
  industries: 'industries_listings',
  industry: 'industries_show',
  recentlyClaimed: 'new_companies_listings',
  mostVisited: 'most_visited',
  managed: 'my_companies',
  followed: 'my_followed_companies',
};
